import { Link } from 'react-router-dom';

const Families = () => (
  <section className="section" id="families">
    <div className="split">
      <div className="split__copy">
        <p className="eyebrow">For parents</p>
        <h2>Screen time you can feel good about.</h2>
        <p>
          A game children genuinely want to play that builds real understanding. Weekly progress updates show exactly what they've mastered. No ads, no addictive loops, no compromises.
        </p>
        <ul className="checklist">
          <li>National Curriculum aligned</li>
          <li>Builds genuine confidence</li>
          <li>Designed by a parent who cares</li>
        </ul>
        <Link to="/curriculum" className="btn btn--primary">Explore curriculum</Link>
      </div>
      <div className="split__panel">
        <div className="report">
          <div>
            <h4>Guardian Update</h4>
            <p>Week of March 1st</p>
          </div>
          <div className="report__score">
            <p>Your child completed <strong>28 minutes</strong> this week and worked on the following skills:</p>
          </div>
          <div className="report__rows">
            <div>
              <span>• Count in multiples of 5</span>
            </div>
            <div>
              <span>• Add two 2-digit numbers</span>
            </div>
            <div>
              <span>• Identify fractions of shapes</span>
            </div>
          </div>
          <div className="report__activities">
            <p><strong>Activities for home:</strong></p>
            <p>Count coins together when shopping. Ask them to group items in 5s. Practice adding prices of two items mentally.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Families;
